import Toast from 'react-bootstrap/Toast';
import type { SubmitValidationError } from '../../types';

/**
 * Port of `commonComponents/errorMessageModelOnSubmit.jsx` — the validation summary
 * shown when a submit fails.
 *
 * All three message strings are reproduced character-for-character, including the
 * truncated "should be less than," in the maximum-hours case and the double space after
 * "For:" in the other two. They read as typos, and they are, but they are the strings
 * users and support see today.
 *
 * The three nested `ref` autofocus callbacks are kept: the container, the toast and the
 * OK button each focus themselves on mount, so the last one to run wins and focus lands
 * on OK. Removing any of them would change where the keyboard goes.
 */
export function ErrorMessageModelOnSubmit({
  maximumHourExceedError,
  minimumHourExceedError,
  invoiceCommentMissingError,
  hide,
}: {
  maximumHourExceedError?: SubmitValidationError;
  minimumHourExceedError?: SubmitValidationError;
  invoiceCommentMissingError?: SubmitValidationError;
  hide: () => void;
}): JSX.Element {
  return (
    <>
      <div
        ref={(inputElement) => {
          if (inputElement) {
            inputElement.focus();
          }
        }}
        tabIndex={0}
        className="error-message-warning"
        style={{
          width: '720px',
          backgroundColor: '#fff',
          position: 'absolute',
          top: 100,
          left: '20%',
          zIndex: 9999,
          float: 'left',
          border: '2px solid #cecece',
          borderRadius: '5px',
        }}
      >
        <Toast
          ref={(inputElement) => {
            if (inputElement) {
              inputElement.focus();
            }
          }}
          className="error-message"
          style={{ width: '720px' }}
          onClose={() => {
            hide();
          }}
        >
          <Toast.Header>
            <div className="alert-ico"></div>
            <strong className="me-auto" tabIndex={0}>
              Error
            </strong>
          </Toast.Header>
          <Toast.Body>
            <div className="modal-body" style={{ fontSize: '12px' }} tabIndex={0}>
              {maximumHourExceedError?.error && (
                <div className="row">
                  Hmm, this does not look right. The number of hours should be less than, For{' '}
                  {maximumHourExceedError?.errorList
                    ?.map((item) => `${item.date} : ${item?.value}`)
                    .join(', ')}
                </div>
              )}
              {minimumHourExceedError?.error && (
                <div className="row">
                  Whoops! Minimum hours should be entered for the following days. Check again and
                  re submit. For:{'  '}
                  {minimumHourExceedError?.errorList
                    ?.map((item) => `${item.date} : ${item?.value}`)
                    .join(', ')}
                </div>
              )}
              {invoiceCommentMissingError?.error && (
                <div className="row">
                  Whoops! Comment should be entered for the following days. Check again and re
                  submit. For:{'  '}
                  {invoiceCommentMissingError?.errorList?.map((item) => item.date).join(', ')}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                ref={(inputElement) => {
                  if (inputElement) {
                    inputElement.focus();
                  }
                }}
                tabIndex={0}
                type="button"
                className="btn modal-button"
                onClick={() => hide()}
              >
                OK
              </button>
            </div>
          </Toast.Body>
        </Toast>
      </div>
    </>
  );
}
